import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Parallax } from 'react-scroll-parallax';

import ImageContainer from '../ImageContainer';

import { getParallaxValue } from '../../helpers/getParallaxValue';

class Gallery extends Component {

  render() {

    const {
      screen,
    } = this.props;

    return (
      <div className="gallery gallery--first">
        <div className="container-inner">
          <div className="gallery__content">
            <div className="gallery-container">
              <Parallax y={getParallaxValue(screen, 1, 1)} className="_medium">
                <ImageContainer src={require('../../static/images/gallery/image-1.jpg').default} />
              </Parallax>
              <Parallax y={getParallaxValue(screen, 1, 2)} className="_small">
                <ImageContainer src={require('../../static/images/gallery/image-2.jpg').default} />
              </Parallax>
            </div>
            <p>Do&nbsp;Deep Tech Garments are meant to&nbsp;embolden and inspire. Pair them together or&nbsp;mix and match with your own wardrobe&nbsp;&mdash; however you wear them, these looks will help you embody the essence of&nbsp;the work we&nbsp;do.<br /><br />Because the style we&nbsp;bring to&nbsp;our everyday lives informs the world we&nbsp;create!</p>
            <div className="gallery-container">
              <Parallax y={getParallaxValue(screen, 1, 3)} className="_medium">
                <ImageContainer src={require('../../static/images/gallery/image-3.jpg').default} />
              </Parallax>
              <Parallax y={getParallaxValue(screen, 1, 4)} className="_medium">
                <ImageContainer src={require('../../static/images/gallery/image-4.png').default} />
              </Parallax>
              <Parallax y={getParallaxValue(screen, 1, 5)} className="_small">
                <ImageContainer src={require('../../static/images/gallery/image-5.jpg').default} />
              </Parallax>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    screen: state.screen.screen,
  }
}

export default connect(mapStateToProps, null)(Gallery);